export const APP_INFO = {
  APP_VERSION: '2.12.0',
  APP_BUILD: '3012617',
  APP_DATE: '11.10.2025',
  MIN_DB_VERSION: '3',
  APP_DEPLOY_VERSION: '1',
  APP_MIN_PERFORMANCE_SCORE: 35,
  MIN_WEBVIEW_VERSION: 80,
};
